export default __webpack_public_path__ + "static/media/851Gkktt_005_subset.38fce46a.woff2";